module.exports = __webpack_public_path__ + "img/hex.a18e25b1.png";